import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Text, TextType } from 'ui-components/components/text';

import ConnectedWorkstations from './connected-workstations';
import { DownloadConnectButton } from './download-connect-button';
import messages from './messages';
import { WorkstationPropType } from './prop-types';
import styles from './style.module.less';
import { useWorkstations } from '../../../hooks/use-workstations';
import { useEnableSupplyPage } from '../../../feature-flags/hooks/use-enable-supply-page';
import Global from '../../../store/global-selectors';
import { SettingsPageTitle } from '../components/settings-page-title/settings-page-title';
import { SuppliesCardContainer } from '../../home-page/version2/supplies-cards/supplies-card-container';
import { SUPPLIES_DISPLAY_LOCATION } from '../../home-page/version2/supplies-cards/supplies-page-constants';
import commonStyles from '../settings-page.module.less';

const NotActivated = () => (
  <>
    <SettingsPageTitle value={messages.header} />
    <Text textType={TextType.Description} value={messages.callDescription} />
    <Text className={styles.subtitle} textType={TextType.H2} value={messages.notInstalledHeader} />
    <Text textType={TextType.Description} value={messages.notInstalledDesc} />
    <DownloadConnectButton />
    <Text className={styles.subtitle} textType={TextType.H2} value={messages.installedHeader} />
    <Text textType={TextType.Description} value={messages.installedDesc} />
    <Text
      className={styles.note}
      formattedMessageValues={{ b: (chunks) => <b>{chunks}</b> }}
      textType={TextType.Paragraph}
      value={messages.note}
    />
  </>
);

const Activated = ({ otherUserWorkstations, userWorkstations }) => {
  const currentUserWorkstationIds = userWorkstations.map((station) => station.workstationId);

  return (
    <>
      <SettingsPageTitle value={messages.shipstationConnect} />
      <Text className={styles.subtitle} textType={TextType.H2} value={messages.yourDevices} />
      <Text textType={TextType.Description} value={messages.info} />
      <ConnectedWorkstations
        currentUserWorkstationIds={currentUserWorkstationIds}
        shouldShowPrintersAndScales
        workstations={userWorkstations}
      />
      <Text className={styles.subtitle} textType={TextType.H2} value={messages.otherUsersDevices} />
      <ConnectedWorkstations shouldShowPrintersAndScales workstations={otherUserWorkstations} />
      <div>
        <Text className={styles.subtitle} textType={TextType.H2} value={messages.additionalInstall} />
        <Text textType={TextType.Description} value={messages.additionalInstallDesc} />
        <DownloadConnectButton />
      </div>
    </>
  );
};

Activated.propTypes = {
  userWorkstations: PropTypes.arrayOf(WorkstationPropType).isRequired,
  otherUserWorkstations: PropTypes.arrayOf(WorkstationPropType).isRequired,
};

export const ShipstationConnect = () => {
  const userId = useSelector(Global.selectUserCurrentUserId);
  const workstations = useWorkstations();
  const enableSupplyPage = useEnableSupplyPage();
  const userWorkstations = useMemo(() => workstations.filter((ws) => ws.userId === userId), [workstations, userId]);

  const otherUserWorkstations = useMemo(() => workstations.filter((ws) => ws.userId !== userId), [workstations, userId]);

  return (
    <div className={commonStyles.content}>
      <div className={commonStyles['limited-width-page']}>
        {workstations.length ? (
          <Activated otherUserWorkstations={otherUserWorkstations} userWorkstations={userWorkstations} />
        ) : (
          <NotActivated />
        )}
        {enableSupplyPage && <SuppliesCardContainer page={SUPPLIES_DISPLAY_LOCATION.SETTINGS_PRINTING_CONNECT} />}
      </div>
    </div>
  );
};
